import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { ItemMediaResponse } from "@src/types/mediaItem";

export const useShare = () => {
  return useMutation({
    mutationFn: (data: {
      email_type?: "share_stock_item";
      type?: string;
      stock_item_id?: number;
      to?: string;
      subject?: string;
      user_comment?: string;
      priceMode?: number;
      extra_attributes?: any;
      email_address?: string;
      share_type?: string;
      share_via?: string;
      share_item_type?: string;
      comments?: string;
      id?: number;
    }) => apiClient.post(Routes.SHARE, data),
  });
};

export const useItemMedia = (stock_item_ids: any) => {
  return useQuery({
    queryKey: ["ITEM_MEDIA", stock_item_ids],
    queryFn: () =>
      apiClient.get<ItemMediaResponse>(Routes.ITEM_MEDIA, {
        params: { stock_item_ids },
      }),
  });
};

export const useShareableLink = () => {
  return useMutation({
    mutationFn: (data: {
      share_type?: string;
      stock_item_id?: number;
      comment?: string;
      priceMode?: number;
      extra_attributes?: any;
      share_via?: string;
      email_address?: string;
      id?: number | null;
      stock_item_type?: string;
      collectionLength?: number;
      name?: string;
    }) => apiClient.post(Routes.SHARE_VIA_LINK, data),
  });
};
